__webpack_require__.p = "/kendo-react/kendo-react-file-manager/";